import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const EditEventSlice = createSlice({
    name: "editEvent",
    initialState,
    reducers: {
        editEventRequest(state) {
            state.loading = true;
        },
        editEventRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        editEventRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        editEventStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    editEventRequest,
    editEventRequestSuccess,
    editEventRequestError,
    editEventStateReset,
} = EditEventSlice.actions;

export default EditEventSlice.reducer;
